import { render } from "./MyAlbums.vue?vue&type=template&id=798183be&scoped=true"
import script from "./MyAlbums.vue?vue&type=script&lang=js"
export * from "./MyAlbums.vue?vue&type=script&lang=js"

import "./MyAlbums.vue?vue&type=style&index=0&id=798183be&scoped=true&lang=css"

import exportComponent from "/Users/macbook/Mubasher/Mubasher/Projects/Live/bling-rock/Project-Live/soundcode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798183be"]])

export default __exports__